import { type IFrontTopPageProps } from '@framework/theme/front/FrontTopPage.tsx';
import { AffixOrder } from '@framework/ui/components/affix/AffixManagerStore.ts';
import { ManagedAffix } from '@framework/ui/components/affix/ManagedAffix.tsx';
import { ContentLayoutWrapper } from '@framework/ui/components/layout/ContentLayoutWrapper.tsx';
import { FlexRow } from '@framework/ui/components/row/FlexRow.tsx';
import { Flex } from 'antd';
import clx from 'classnames';
import { down } from 'styled-breakpoints';
import { useBreakpoint } from 'styled-breakpoints/react-styled';
import styled, { useTheme } from 'styled-components';
import { FrontBreadcrumbsPortal } from './container/FrontBreadcrumbsContainer.tsx';
import { FrontPageActionsPortal } from './container/FrontPageActionsContainer.tsx';
import { FrontPageTitlePortal } from './container/FrontPageTitleContainer.tsx';

const FrontTopPageFlexRow = styled(FlexRow)`
  gap: 8px;
  &.is-mobile {
    // se mobile portiamo tutto in colonna
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  #front-page-title--portal > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
    > .ant-typography {
      font-size: 24px;
      line-height: 24px;
      font-weight: 600;
      margin-bottom: 0;
    }
  }
`;
const StyledPageHead = styled.div`
  position: relative;
  z-index: 9;

  display: flex;
  flex-direction: column;
  padding: 8px 0px;
  background-color: ${props => props.theme.colorBgContainer ?? '#fff'};
  box-shadow: ${props => props.theme.boxShadow};
  .dossier-page &,
  .dossier-list-page & {
    background-color: ${props => props.theme.colorBgDossierCard};
  }

  #front-page-title--portal {
    padding-bottom: 4px;
    padding-top: 6px;
    &:empty {
      padding: 0;
    }
  }
  .dossier-page-header & {
    background-color: ${props => props.theme.colorBgDossierCard};
  }
`;
const TopPagePadding = styled.div`
  padding: 0 24px;
  ${down('sm')} {
    padding: 0 12px;
  }
`;

/**
 * Fascia in alto all'inizio del content della pagina (primo elemento del <main />)
 */
export function FrontTopPage(props: IFrontTopPageProps) {
  const theme = useTheme();
  const isMobile = useBreakpoint(down('sm'));

  // Gestione interna della larghezza del'header
  const headerBoxed = theme.boxedFrontofficeHeaderFooterLayoutFlag ?? false;

  return (
    <ManagedAffix
      order={AffixOrder.PAGE_HEADER}
      asGlobalOffset
      breakpoint="sm"
      style={{ zIndex: 9 }}
    >
      <StyledPageHead>
        <ContentLayoutWrapper boxed={headerBoxed}>
          <TopPagePadding>
            <FrontTopPageFlexRow
              className={clx({ 'is-mobile': isMobile })}
              right={<FrontPageActionsPortal />}
            >
              <Flex vertical>
                <FrontBreadcrumbsPortal />
                <FrontPageTitlePortal />
              </Flex>
            </FrontTopPageFlexRow>
          </TopPagePadding>
        </ContentLayoutWrapper>
      </StyledPageHead>
    </ManagedAffix>
  );
}
